import { LiveFeedContainer } from '@/components/features/LiveEvents';

/**
 * `/live` route — the Live page (Live tab in the bottom nav): all events
 * resolving within the admin-set window, grouped by time-to-resolution
 * (Short Markets / Closing Soon / Today / This Week).
 *
 * The top bar and bottom nav are owned by the app shell singletons; the page
 * body (header strip, pills, anchors, groups) lives in
 * {@link LiveFeedContainer}.
 */
export function LivePage() {
  return (
    <div className="flex flex-1 flex-col pt-3 pb-[calc(82px+env(safe-area-inset-bottom))] md:pb-0">
      {/* Same desktop gutters as HomePage — keeps the feed off the side nav. */}
      <div className="flex flex-1 flex-col items-center md:px-6 lg:px-8 xl:px-10">
        <LiveFeedContainer />
      </div>
    </div>
  );
}
